import type { GraphQLTypes, InputType } from '@zeus/index'
import { $, Selector } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const learnerProfileSelector = Selector('LearnerProfile')({
  id: true,
  firstName: true,
  lastName: true,
  email: true,
  username: true,
  company: true,
  department: true,
  status: true,
  roleName: true,
  roleId: true,
  createdAt: true,
  groups: { id: true, name: true },
  trainingSeconds: true,
  loginCount: true,
  lastLoginAt: true,
  averageDaysBetweenLogins: true,
  completedModules: true,
  totalModules: true,
})

/** Fiche apprenant (#242) : identité, groupes et indicateurs. */
export const GQL_LEARNER_PROFILE = typedGql('query', { scalars })({
  learnerProfile: [{ userId: $('userId', 'ID!') }, learnerProfileSelector],
})

export type LearnerProfileData = InputType<GraphQLTypes['LearnerProfile'], typeof learnerProfileSelector, typeof scalars>

/** Journal des connexions d'un compte, page par page (#242). */
export const GQL_LEARNER_LOGINS = typedGql('query', { scalars })({
  learnerLogins: [
    { userId: $('userId', 'ID!'), skip: $('skip', 'Int'), take: $('take', 'Int') },
    { total: true, events: { id: true, at: true, method: true } },
  ],
})
